import React from 'react';
import styles from './styles.module.scss';

interface IconWithStackedTextProps {
  icon: React.ReactNode;
  title: string;
  subtitle: string;
  className?: string;
}

const IconWithStackedText: React.FC<IconWithStackedTextProps> = ({
  icon,
  title,
  subtitle,
  className
}) => {
  return (
    <div className={`${styles.iconWithStackedText} ${className ?? ''}`}>
      <div className={styles.icon}>{icon}</div>
      <div className={styles.textSideBySide}>
        <span className={styles.title}>{title}</span>
        <span className={styles.subtitle}>{subtitle}</span>
      </div>
    </div>
  );
};

export default IconWithStackedText;
